// Advisor softphone on Telnyx (plan B3): per-advisor WebRTC login tokens, presence + heartbeat, advisor calls placed
// and bridged by LIA's Call Control, transfers; admin seats and the Credential Connection setting.
import * as S from './api-softphone.js';
import { IdParam, route, W, Ws } from './route-def.js';

export const softphoneRoutes = {
  getSoftphoneState: route({
    method: 'GET', path: '/workspaces/:workspaceId/softphone', summary: 'Softphone: estado del asesor (asiento, presencia, llamada actual)', tag: 'softphone',
    minRole: 'advisor', params: Ws, response: S.SoftphoneStateSchema,
  }),
  mintSoftphoneToken: route({
    method: 'POST', path: '/workspaces/:workspaceId/softphone/token', summary: 'Softphone: token de acceso WebRTC de corta duración (no se guarda)', tag: 'softphone',
    minRole: 'advisor', params: Ws, response: S.SoftphoneTokenSchema,
  }),
  softphoneHeartbeat: route({
    method: 'POST', path: '/workspaces/:workspaceId/softphone/heartbeat', summary: 'Softphone: latido del navegador (presencia)', tag: 'softphone',
    minRole: 'advisor', params: Ws, body: S.SoftphoneHeartbeatSchema, response: S.SoftphoneStateSchema,
  }),
  setSoftphonePresence: route({
    method: 'PUT', path: '/workspaces/:workspaceId/softphone/presence', summary: 'Softphone: disponible o ausente', tag: 'softphone',
    minRole: 'advisor', params: Ws, body: S.SetSoftphonePresenceSchema, response: S.SoftphoneStateSchema,
  }),
  startSoftphoneCall: route({
    method: 'POST', path: '/workspaces/:workspaceId/softphone/calls', summary: 'Softphone: llamar a un contacto o número desde una línea de Telnyx', tag: 'softphone',
    minRole: 'advisor', params: Ws, body: S.StartSoftphoneCallSchema, response: S.SoftphoneStateSchema, status: 202,
  }),
  hangupSoftphoneCall: route({
    method: 'POST', path: '/workspaces/:workspaceId/softphone/calls/:callId/hangup', summary: 'Softphone: colgar la llamada', tag: 'softphone',
    minRole: 'advisor', params: W({ callId: IdParam }), response: S.SoftphoneStateSchema,
  }),
  transferSoftphoneCall: route({
    method: 'POST', path: '/workspaces/:workspaceId/softphone/calls/:callId/transfer', summary: 'Softphone: transferir a otro asesor o a un número', tag: 'softphone',
    minRole: 'advisor', params: W({ callId: IdParam }), body: S.TransferSoftphoneCallSchema, response: S.SoftphoneStateSchema,
  }),
  getSoftphoneAdmin: route({
    method: 'GET', path: '/workspaces/:workspaceId/softphone/admin', summary: 'Softphone: asientos de asesores y conexión de credenciales', tag: 'softphone',
    minRole: 'admin', params: Ws, response: S.SoftphoneAdminSchema,
  }),
  updateSoftphoneSettings: route({
    method: 'PUT', path: '/workspaces/:workspaceId/telnyx/connections/:connectionId/softphone', summary: 'Softphone: Credential Connection de Telnyx y tiempo de timbrado', tag: 'softphone',
    minRole: 'admin', params: W({ connectionId: IdParam }), body: S.UpdateSoftphoneSettingsSchema, response: S.SoftphoneAdminSchema,
  }),
  updateSoftphoneSeat: route({
    method: 'PUT', path: '/workspaces/:workspaceId/softphone/seats/:membershipId', summary: 'Softphone: activar o desactivar el asiento de un asesor', tag: 'softphone',
    minRole: 'admin', params: W({ membershipId: IdParam }), body: S.UpdateSoftphoneSeatSchema, response: S.SoftphoneAdminSchema,
  }),
} as const;
